
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1653368449777",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "17693",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M794.112 0H231.936C104.96 0 0 104.96 0 231.424v558.08C0 919.04 104.96 1024 231.936 1024h559.616c129.536 0 231.936-104.96 231.936-231.424V231.424c3.072-126.464-102.4-231.424-229.376-231.424z m-378.88 675.328c-34.304 0-60.928-7.168-92.672-12.288l-95.232 44.032 27.136-80.384c-68.608-46.08-107.52-107.52-107.52-180.224 0-126.976 119.808-226.816 268.8-226.816 132.096 0 246.784 80.384 271.36 187.904-7.168 0-16.896-2.56-27.136-2.56-126.976 0-227.328 95.232-227.328 211.968 0 19.456 2.56 38.912 7.168 56.32-7.168-0.512-16.896 2.048-24.576 2.048zM808.96 768l19.456 66.048-73.216-38.912c-27.136 7.168-53.76 12.288-80.896 12.288-126.976 0-227.328-87.552-227.328-195.072s100.352-195.072 227.328-195.072c119.808 0 227.328 87.552 227.328 195.072 2.56 62.976-38.912 114.176-92.672 155.648zM361.472 365.568c0 19.456-16.896 36.352-36.864 36.352s-36.864-16.896-36.864-36.352 16.896-36.352 36.864-36.352 36.864 16.896 36.864 36.352z m115.2 0c0-19.456 16.896-36.352 36.864-36.352 19.456 0 36.864 16.896 36.864 36.352s-16.896 36.352-36.864 36.352c-22.528 0.512-36.864-14.336-36.864-36.352z m307.712 187.904c0 16.896-14.848 29.184-29.184 29.184-16.896 0-29.184-14.848-29.184-29.184 0-16.896 14.848-29.184 29.184-29.184 14.848 0 29.184 12.288 29.184 29.184z m-148.992 0c0 16.896-14.848 29.184-29.184 29.184-14.848 0-29.184-14.848-29.184-29.184 0-14.848 14.848-29.184 29.184-29.184 14.336 0 29.184 12.288 29.184 29.184z",
        "p-id": "17694"
      }
    }
  ]
})
    }
  